export const uk = {
    'error-text': 'Не удалось загрузить страницу, попробуйте еще раз',
    'error-text-header': 'Ошибка загрузки'
};
